/**
 * SelfPerfTable — the Self Perf Assessment tab: the rows of the uploaded
 * self-perf (UDF) file, as the server returned them.
 *
 * Port of legacy views/ManagePortfolio/SelfPerfTable.vue. Its columns are not
 * fixed — they are the keys of the first row, i.e. whatever the file's columns
 * are — and so are these. Two legacy oddities are not kept: it showed only the
 * FIRST TWO keys (here: every column the file has), and it padded the table
 * with four empty columns. Read-only, as legacy; pages of 10 / 20 / 50.
 */
import { useMemo } from 'react';

import { Table } from '@components/common/Table';

/** Bookkeeping fields that are not columns of the file. */
const HIDDEN_KEYS = new Set(['isSaved', '_rowId', 'Remarks']);

export function SelfPerfTable({ rows }) {
  const columns = useMemo(() => {
    const keys = Object.keys(rows[0] ?? {}).filter((key) => !HIDDEN_KEYS.has(key));
    return keys.map((key) => ({
      key,
      header: key,
      render: (row) => {
        const value = row[key];
        return value === null || value === undefined || value === '' ? '—' : String(value);
      },
    }));
  }, [rows]);

  return (
    <Table
      caption="Self Perf Assessment"
      columns={columns}
      rows={rows}
      rowKey={(row) => row._rowId}
      pageSizeOptions={[10, 20, 50]}
      emptyMessage="No data found"
    />
  );
}

export default SelfPerfTable;
